import type { Sample } from '@charts';
import { useLifeEvents } from '@/data/sources/lifeEvents';
import { WEEK_MS } from '../lib/time';

export interface HeartRateData {
  samples: Sample[];
  resting: Sample[];
  domain: [number, number];
}

export const useHeartRate = (): HeartRateData => {
  const { data } = useLifeEvents('week');
  const events = data?.events ?? [];
  const now = Date.now();

  return {
    samples: (data?.heartRate ?? []).map((point) => ({
      t: point.time.getTime() / 1000,
      value: point.value,
    })),
    resting: events.flatMap((e) =>
      e.vitals?.restingHeartRate != null
        ? [
            {
              t: e.eventTime.getTime() / 1000,
              value: e.vitals.restingHeartRate,
            },
          ]
        : []
    ),
    domain: [(now - WEEK_MS) / 1000, now / 1000],
  };
};
